/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Suffix_LabelInputs */

const en_audio_embed_export_suffix_label = /** @type {(inputs: Audio_Embed_Export_Suffix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Output filename suffix`)
};

const fr_audio_embed_export_suffix_label = /** @type {(inputs: Audio_Embed_Export_Suffix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`suffixe du nom de fichier de sortie`)
};

const de_audio_embed_export_suffix_label = /** @type {(inputs: Audio_Embed_Export_Suffix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateinamenserweiterung für die Ausgabedatei`)
};

const it_audio_embed_export_suffix_label = /** @type {(inputs: Audio_Embed_Export_Suffix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`suffisso del nome del file di output`)
};

const ru_audio_embed_export_suffix_label = /** @type {(inputs: Audio_Embed_Export_Suffix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Суффикс имени выходного файла`)
};

const es_audio_embed_export_suffix_label = /** @type {(inputs: Audio_Embed_Export_Suffix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sufijo del nombre del archivo de salida`)
};

const zh_cn2_audio_embed_export_suffix_label = /** @type {(inputs: Audio_Embed_Export_Suffix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输出文件名后缀`)
};

const ja_audio_embed_export_suffix_label = /** @type {(inputs: Audio_Embed_Export_Suffix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出力ファイル名の接尾辞`)
};

const hi_audio_embed_export_suffix_label = /** @type {(inputs: Audio_Embed_Export_Suffix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आउटपुट फ़ाइलनाम प्रत्यय`)
};

const pt_pt2_audio_embed_export_suffix_label = /** @type {(inputs: Audio_Embed_Export_Suffix_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sufixo do nome do arquivo de saída`)
};

/**
* | output |
* | --- |
* | "Output filename suffix" |
*
* @param {Audio_Embed_Export_Suffix_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_suffix_label = /** @type {((inputs?: Audio_Embed_Export_Suffix_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Suffix_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_suffix_label(inputs)
	if (locale === "de") return de_audio_embed_export_suffix_label(inputs)
	if (locale === "it") return it_audio_embed_export_suffix_label(inputs)
	if (locale === "ru") return ru_audio_embed_export_suffix_label(inputs)
	if (locale === "es") return es_audio_embed_export_suffix_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_suffix_label(inputs)
	if (locale === "ja") return ja_audio_embed_export_suffix_label(inputs)
	if (locale === "hi") return hi_audio_embed_export_suffix_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_suffix_label(inputs)
	return en_audio_embed_export_suffix_label(inputs)
});